module.exports = __webpack_public_path__ + "img/fm.c13087c2.svg";